/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Loading_StreamInputs */



/**
* | output |
* | --- |
* | "Loading Stream..." |
*
* @param {Load_Project_File_Status_Loading_StreamInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_loading_stream = /** @type {((inputs?: Load_Project_File_Status_Loading_StreamInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Loading_StreamInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du flux...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stream wird geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento dello stream in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка потока...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando transmisión...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载流...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ストリームを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्ट्रीम लोड हो रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando o stream...")
	return /** @type {LocalizedString} */ ("Loading Stream...")
});